export class SalesPerson {
    apiToken!: string;
    createdAt!: string;
    mobileNo!: string;
    name!: string;
    role!: string;
    updateAt!: string;
    userId!: string;
    _id!: string;
}